

<div 
      [style.--color]="textColor"
      [style.--background-color]="color"
      >
      <ng-content></ng-content>
</div>